import React, { useState } from "react";
import "../UIcss/Tables.css";
import { tableData } from "./tableData.js";
import CodeViewer from "./CodeViewer.jsx";
import Pagination from "./Pagination.jsx";
import { FaTable } from "react-icons/fa";
import { LuCopy } from "react-icons/lu";

const Tables = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 22; // Show 12 tables per page

  const [viewerState, setViewerState] = useState({
    isOpen: false,
    name: "",
    jsx: "",
    css: "",
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(tableData.length / itemsPerPage);

  const openViewer = (table) => {
    setViewerState({
      isOpen: true,
      name: `Table Style ${table.id}`,
      jsx: table.html,
      css: table.css,
    });
  };

  const closeViewer = () => {
    setViewerState({ ...viewerState, isOpen: false });
  };

  const handleOpenCode = (e, table) => {
    e.stopPropagation();
    openViewer(table);
  };

  return (
    <>
      <div className="tables-container">
        <div className="library-header">
          <div className="header-content">
            <h1>
              <FaTable /> Tables <span>Library</span>
            </h1>
          </div>
        </div>
        <div className="tables-grid">
          {currentItems.map((table) => (
            <div
              key={table.id}
              className="table-item-card"
              onClick={() => openViewer(table)}
            >
              <button
                className="view-code-btn"
                onClick={(e) => handleOpenCode(e, table)}
                title="View Code"
              >
                <LuCopy size={18} />
              </button>
              <div className="table-visual-area">
                <div className="table-preview-container">
                  <table className={table.className}>
                    <thead>
                      <tr>
                        <th>Invoice</th>
                        <th>Client</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>#INV-001</td>
                        <td>Acme Corp</td>
                        <td>Oct 24, 2024</td>
                        <td>
                          <span
                            style={{
                              background: "#10b98120",
                              color: "#10b981",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            Paid
                          </span>
                        </td>
                        <td>$1,200.00</td>
                      </tr>
                      <tr>
                        <td>#INV-002</td>
                        <td>Global Inc</td>
                        <td>Oct 22, 2024</td>
                        <td>
                          <span
                            style={{
                              background: "#f59e0b20",
                              color: "#f59e0b",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            Pending
                          </span>
                        </td>
                        <td>$850.00</td>
                      </tr>
                      <tr>
                        <td>#INV-003</td>
                        <td>Tech Sol</td>
                        <td>Oct 20, 2024</td>
                        <td>
                          <span
                            style={{
                              background: "#10b98120",
                              color: "#10b981",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            Paid
                          </span>
                        </td>
                        <td>$2,400.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="table-label">Style {table.id}</div>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />

        <CodeViewer
          isOpen={viewerState.isOpen}
          onClose={closeViewer}
          componentName={viewerState.name}
          jsxCode={viewerState.jsx}
          cssCode={viewerState.css}
        />
      </div>
    </>
  );
};

export default Tables;
